module.exports = "pegasus_template/assets/presentation_bg.png";